import { Outlet } from "react-router-dom";
import { Suspense } from "react";
import Navbar from "../components/shared/navbar/navbar";
import Loading from "../components/shared/loading/loading";
import Footer from "../components/shared/footer/footer";

export default function Root() {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        <Suspense fallback={<Loading />}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}
